import { useLanguage } from '@hooks/useLanguage';

export function useIsSpecificLanguage(language: string) {
  const currentLanguage = useLanguage();
  return language === currentLanguage;
}
